import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const userApiService = createApi({
  reducerPath: "userApi",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Wishlist"], // Define Wishlist tag
  endpoints: (builder) => ({
    createUser: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `user/usercreate${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    updateUser: builder.mutation({
      query: (args) => {
        const { id, payload, params } = args;
        let query = queryParams(params);
        return {
          url: `user/update/${id}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
    handleWishlist: builder.mutation({
      query: ({ id, params }) => {
        let query = queryParams(params);
        return {
          url: `user/handle-wishlist/${id}${query}`,
          method: "PUT",
        };
      },
      invalidatesTags: ["Wishlist"], // Invalidate Wishlist tag
    }),
    handleSaveforlater: builder.mutation({
      query: ({ courseId, params }) => {
        let query = queryParams(params);
        return {
          url: `user/handle-saveforlater/${courseId}${query}`,
          method: "PUT",
        };
      },
      invalidatesTags: ["SaveForLater"],
    }),
    getStudentByCourse: builder.query({
      query: ({ courseId, params }) => {
        let query = queryParams(params);
        return {
          url: `user/students/${courseId}${query}`,
          method: "GET",
        };
      },
    }),
    getInstructors: builder.query({
      query: ({ id, params }) => {
        let query = queryParams(params);
        return {
          url: id
            ? `user/instructors/${id}${query}`
            : `user/instructors${query}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
    }),
    getInstructorByUsername: builder.query({
      query: ({ username, params }) => {
        let query = queryParams(params);
        return {
          url: `user/instructor/${username}${query}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
    }),
    getWishlist: builder.query({
      query: (params) => {
        let query = queryParams(params);
        return {
          url: `user/wishlist${query}`,
          method: "GET",
        };
      },
      providesTags: ["Wishlist"],
      keepUnusedDataFor: 0,
    }),
    getSaveforlater: builder.query({
      query: (params) => {
        let query = queryParams(params);
        return {
          url: `user/saveforlater${query}`,
          method: "GET",
        };
      },
      providesTags: ["SaveForLater"],
      keepUnusedDataFor: 0,
    }),
    verifyCourseCreation: builder.query({
      query: (params) => {
        let query = queryParams(params);
        return {
          url: `user/verify-course-creation${query}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
    }),
    checkFileUploadSize: builder.mutation({
      query: (args) => {
        const { id, params } = args;
        let query = queryParams(params);
        return {
          url: `user/check-file-upload-size/${id}${query}`,
          method: "GET",
        };
      },
    }),
    changePassword: builder.mutation({
      query: ({ payload, params }) => {
        let query = queryParams(params);
        return {
          url: `user/change-password${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getFeaturedCreator: builder.query({
      query: (params) => {
        const query = queryParams(params);
        return {
          url: `user/featured-user${query}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useCreateUserMutation,
  useUpdateUserMutation,
  useHandleWishlistMutation,
  useHandleSaveforlaterMutation,
  useGetStudentByCourseQuery,
  useGetInstructorsQuery,
  useGetInstructorByUsernameQuery,
  useGetWishlistQuery,
  useGetSaveforlaterQuery,
  useVerifyCourseCreationQuery,
  useCheckFileUploadSizeMutation,
  useChangePasswordMutation,
  useGetFeaturedCreatorQuery,
} = userApiService;
